import { mapState, mapActions } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'

export const GeneralRegistrationSettingsCacheMixin = {
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapState('GeneralRegistrationSettings', [
      'fetchedGeneralRegistrationSettings',
      'fetchingGeneralRegistrationSettings',
      'attemptedGeneralRegistrationSettings',
      'generalRegistrationSettings'
    ]),
    enabled () {
      return this.generalRegistrationSettings ? this.generalRegistrationSettings.enabled : false
    },
    petsLimit () {
      return this.generalRegistrationSettings ? this.generalRegistrationSettings.petsLimit : 6
    }
  },
  methods: {
    ...mapActions('GeneralRegistrationSettings', [
      'fetchGeneralRegistrationSettings'
    ]),
    refreshGeneralRegistrationSettings () {
      if (!this.fetchedGeneralRegistrationSettings && !this.fetchingGeneralRegistrationSettings) {
        this.tryFetchGeneralRegistrationSettings()
      }
    },
    tryFetchGeneralRegistrationSettings () {
      const self = this
      self.error = ''
      self.fetchGeneralRegistrationSettings()
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshGeneralRegistrationSettings()
  }
}
